// extracted by mini-css-extract-plugin
export default {"backdrop":"InfoModal_backdrop__B53ay","card":"InfoModal_card__IBnl5","close":"InfoModal_close__HQqE9","title":"InfoModal_title__+yjh-","body":"InfoModal_body__ThYOE"};